<template>
    <div v-if="dataScoreWeekMeeting.week_meetings.length > 0" id="tableScoreWeekMeeting" class="mt-4">
        <div>
            <h3>II. Kết quả họp tuần</h3>
        </div>
        <div class="mb-3 mt-3">
            <b class="mb-2 text-white" style="background-color: rgb(93, 4, 176); border-radius: 8px; padding: 12px">Điểm
                tích họp tuần:
                <span>{{ dataScoreWeekMeeting.total_score_meeting >= 0 && dataScoreWeekMeeting.total_score_meeting !== null ? dataScoreWeekMeeting.total_score_meeting : "Chưa có" }}</span></b>
        </div>
        <div class="example-preview w-75">
            <table class="table table-vertical-center table-bordered" element-loading-text="Loading...">
                <thead>
                <tr style="background-color: #F8F8F8; word-break: auto-phrase">
                    <th class="bg-header__table">Tiêu chí</th>
                    <th class="bg-header__table" v-for="(item, index) in dataScoreWeekMeeting.week_meetings[1].week" :key="item.week_meetings">Kết quả tuần {{
                            index + 1
                        }}
                    </th>
                </tr>
                </thead>
                <tbody v-if="dataScoreWeekMeeting.week_meetings">
                <tr v-for="(scoreWeekMeeting, index) in dataScoreWeekMeeting.week_meetings" :key="index">
                    <td style="word-break: break-word; width:25%">{{ scoreWeekMeeting.criteria_name }}</td>
                    <td class="text-center" v-for="(value_week, i) in scoreWeekMeeting.week" :key="i">
                        <div class="justify-content-edutalk relative">
                            <el-switch v-model="value_week[`week-${i+1}`]"
                                       :active-value="1"
                                       :inactive-value="0"
                                       @change="changeMeetingValue(scoreWeekMeeting, `week-${i+1}`,  value_week[`week-${i+1}`])">

                            </el-switch>
                            <div style="width: 80px; "> {{ value_week[`week-${i+1}`] == 1 || value_week[`week-${i+1}`] == true ? 'Đạt' : 'Không đạt'}}</div>
                            <div v-show="scoreWeekMeetingSelected?.criteria_id === scoreWeekMeeting?.criteria_id && weekSelected === `week-${i+1}` && isShowPopup"
                                 ref="popup"
                                 class="popup-suggest">
                                <div style="font-weight: 700; display: flex;">Tự động điền</div>
                                <div style="word-break: break-word; white-space: nowrap">Chấm tất cả tiêu chí của các tuần là <b>{{ status }}</b>?
                                </div>
                                <div
                                    style="display: flex; justify-content: center; align-items: center; gap: 10px">
                                    <i class="el-icon-circle-check"
                                       style="color: #0C9200; cursor: pointer; font-size: 25px;"
                                       @click="setAllValue"></i>
                                    <i class="el-icon-circle-close"
                                       style="color: red; cursor: pointer; font-size: 25px;"
                                       @click="isShowPopup = false"></i>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="text-center">
                    <td colspan="7">
                        Không có dữ liệu
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="w-100">
            <label for=""><b>Nhận xét:</b></label>
            <el-input v-model="dataScoreWeekMeeting.description" :disabled="is_disable" :style="is_disable ? 'color:rgb(0 0 0 / 42%)' : ''"
                      class="w-100" placeholder="Nhập nhận xét"></el-input>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        dataScoreWeekMeeting: {
            type: [Array, Object], // Chấp nhận cả mảng và đối tượng
            default: () => []
        },

        is_disable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentYear: '',
            currentMonth: '',
            weekCounts: '',
            percents: [
                {id: 0, value: "Không đạt"},
                {id: 1, value: "Đạt"},
            ],
            weekSelected: null,
            scoreWeekMeetingSelected: null,
            isShowPopup: false,
            status: '',
            statusNum: null,

        };
    },
    computed: {},
    mounted() {
        this.getCurrentYearAndMonth();
    },

    methods: {
        changeColor(status) {
            switch (status) {
                case 0:
                    return 'kra-text-red';
                case 1:
                    return 'kra-text-green';
                default:
                    return 'kra-text-black';
            }
        },

        getCurrentYearAndMonth() {
            const date = new Date();
            this.currentYear = date.getFullYear();
            this.currentMonth = String(date.getMonth() + 1).padStart(2, "0");
        },
        changeMeetingValue(scoreWeekMeeting, weekSelected, value) {
            this.scoreWeekMeetingSelected = scoreWeekMeeting;
            this.weekSelected = weekSelected;
            this.isShowPopup = weekSelected === 'week-1' || weekSelected === 'week-2';
            this.statusNum = value
            this.status = value === '1' ? 'Đạt' : 'Không đạt';
            this.changeWeekScore(this.dataScoreWeekMeeting.week_meetings)
        },
        setAllValue() {
            this.dataScoreWeekMeeting.week_meetings?.forEach((item) => {
                item.week.forEach((v, i) => {
                    v[`week-${i + 1}`] = this.statusNum
                });
            })
            this.isShowPopup = false;
            this.changeWeekScore(this.dataScoreWeekMeeting.week_meetings)
        },
        changeWeekScore(data) {
            let count_total = 0;
            data.forEach((item) => {
                item.week.forEach((v, i) => {
                    let count_item = v[`week-${i + 1}`];
                    if (count_item === '1' || count_item === 1) {
                        count_total++
                    }

                    if (!count_total && count_item === 0) {
                        count_total = 0
                    }
                });
            });
            return this.dataScoreWeekMeeting.total_score_meeting = count_total
        },
    },
}
</script>

<style>
#tableScoreWeekMeeting .input_percents .el-input__inner {
    border: none !important;
    font-size: 16px;
    font-weight: 400;
}
.example-preview .relative {
    position: relative;
}
.bg-header__table {
    background-color: #472F92 !important;
    text-align: start;
    color: white;
}
</style>
